// Integrações com APIs públicas para preenchimento automático de cadastros.

export interface ViaCepResult {
  cep: string;
  logradouro: string;
  complemento?: string;
  bairro: string;
  localidade: string;   // nome do município
  uf: string;
  ibge?: string;        // código IBGE (7 dígitos)
  erro?: boolean;
}

export async function fetchCep(cep: string): Promise<ViaCepResult | null> {
  const c = (cep || '').replace(/\D/g, '');
  if (c.length !== 8) return null;
  try {
    const resp = await fetch(`https://viacep.com.br/ws/${c}/json/`);
    if (!resp.ok) return null;
    const data = await resp.json();
    if (data.erro) return null;
    return data as ViaCepResult;
  } catch {
    return null;
  }
}

export interface BrasilApiCnpj {
  cnpj: string;
  razao_social: string;
  nome_fantasia?: string;
  situacao_cadastral?: number; // 2=ativa
  descricao_situacao_cadastral?: string;
  cnae_fiscal?: number;
  cnae_fiscal_descricao?: string;
  logradouro?: string;
  numero?: string;
  bairro?: string;
  complemento?: string;
  cep?: string;
  uf?: string;
  municipio?: string;
  ddd_telefone_1?: string;
  email?: string;
  codigo_municipio_ibge?: number;
  natureza_juridica?: string;
  data_inicio_atividade?: string;
  // ... outros campos
}

export async function fetchCnpj(cnpj: string): Promise<BrasilApiCnpj | null> {
  const c = (cnpj || '').replace(/\D/g, '');
  if (c.length !== 14) return null;
  try {
    const resp = await fetch(`https://brasilapi.com.br/api/cnpj/v1/${c}`);
    if (!resp.ok) return null;
    const data = await resp.json();
    return data as BrasilApiCnpj;
  } catch {
    return null;
  }
}

/** Formata CEP 01310100 → 01310-100 */
export function formatCEP(cep: string | null | undefined): string {
  if (!cep) return '';
  const c = String(cep).replace(/\D/g, '');
  if (c.length !== 8) return c;
  return `${c.slice(0, 5)}-${c.slice(5)}`;
}

/** Formata telefone 8399999999 → (83) 9999-9999 ou (83) 99999-9999 */
export function formatTelefone(tel: string | null | undefined): string {
  if (!tel) return '';
  const t = String(tel).replace(/\D/g, '');
  if (t.length === 10) return `(${t.slice(0, 2)}) ${t.slice(2, 6)}-${t.slice(6)}`;
  if (t.length === 11) return `(${t.slice(0, 2)}) ${t.slice(2, 7)}-${t.slice(7)}`;
  return t;
}
